import React, {Component} from 'react';
import Cookie from 'js-cookie';
import LoginForm from '../auth/login-form';
import {logOutLinkStyle} from '../styles';
import UserConsole from './users';
import ProjectConsole from './projects';
import ActivityConsole from './activity-console';

export default class AdminConsole extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAuthenticated: Cookie.get('cbadviser-user') !== undefined,
            view: 'users'
        }
    }

    logOut = () => {
        Cookie.remove('cbadviser-user');
        this.setState({isAuthenticated: false});
    };

    render() {
        if (this.state.isAuthenticated) {
            let viewComponent = undefined;
            if (this.state.view === 'users') viewComponent = <UserConsole/>;
            if (this.state.view === 'projects') viewComponent = <ProjectConsole/>;
            if (this.state.view === 'activity') viewComponent = <ActivityConsole/>;

            return(
                <div style={{marginTop: '20px'}}>
                    <div className="pull-right"><a href="#" onClick={this.logOut} style={logOutLinkStyle}>Log out</a></div>
                    <div style={{marginBottom: '10px'}}>
                        <ul className="nav nav-tabs" role="tablist">
                            <li role="presentation" className={this.state.view === 'users' ? 'active' : ''}>
                                <a href="#" role="tab" onClick={() => this.setState({view: 'users'})}>Users</a>
                            </li>
                            <li role="presentation" className={this.state.view === 'projects' ? 'active' : ''}>
                                <a href="#" role="tab" onClick={() => this.setState({view: 'projects'})}>Projects</a>
                            </li>
                            <li role="presentation" className={this.state.view === 'activity' ? 'active' : ''}>
                                <a href="#" role="tab" onClick={() => this.setState({view: 'activity'})}>Activity</a>
                            </li>
                        </ul>
                    </div>
                    {viewComponent}
                </div>);
        } else {
            return(<LoginForm isAdminOnly={true} onLogIn={() => this.setState({isAuthenticated: true})}/>);
        }
    }
}


// WEBPACK FOOTER //
// ./src/admin/admin-console.js